import { Injectable } from '@angular/core';
import { SettingsService } from '@delon/theme';

import { EINVOICE_TAXTYPE } from '@core';

import { InlineAddConfig, InlineAddField } from './inline-add-panel.component';

@Injectable({
  providedIn: 'root'
})
export class TaxCodeAddConfigService {
  constructor(private settingsService: SettingsService) {}

  getTaxCodeConfig(isOutputTax: boolean): InlineAddConfig {
    const country = this.settingsService.user['company']?.['country'];
    const isMalaysia = country === 'MY';

    const fields: InlineAddField[] = [
      {
        name: 'code',
        label: 'Tax #',
        type: 'text',
        required: true,
        isInstantData: true,
        maxLength: 50,
        placeholder: 'Enter tax code',
        size: 'half'
      },
      {
        name: 'description',
        label: 'Tax Description',
        type: 'text',
        required: true,
        maxLength: 250,
        placeholder: 'Enter tax description',
        size: 'half'
      },
      {
        name: 'rate',
        label: 'Rate (%)',
        type: 'number',
        required: true,
        placeholder: 'Enter tax rate',
        size: 'half'
      }
    ];

    // Only include e-Invoice Tax Type field for Malaysia
    if (isMalaysia) {
      fields.push({
        name: 'eInvoiceTaxType',
        label: 'e-Invoice Tax Type',
        type: 'select',
        required: true,
        options: EINVOICE_TAXTYPE.map(item => ({
          value: item.value,
          label: `${item.value} - ${item.name}`
        })),
        placeholder: 'Select e-invoice tax type',
        size: 'half',
        defaultValue: ''
      });
    }

    return {
      modelType: 'taxcode',
      title: 'Tax Code',
      apiEndpoint: 'api/taxcodes/create',
      submitButtonText: 'Save',
      cancelButtonText: 'Cancel',
      fieldMapping: {
        'taxCode': 'code'
      },
      selectionConfig: {
        targetField: 'taxCodeId',
        valueField: 'id',
        labelField: 'code'
      },
      hiddenData: {
        isActive: true,
        isOutputTax: isOutputTax,
        govTaxCode: 'NA'
      },
      fields: fields
    };
  }

  
}
